import React from 'react';
import { Col, Row } from "react-bootstrap";
import { KeyboardArrowDown } from '@material-ui/icons';
import DataTable from 'react-data-table-component';
import { connect } from 'react-redux';
import { getAdminNotificatiosAction } from '../../actions/NotificationActions';
import noRecord from './../../assets/img/no-record.png';

/**
 * Class Component for admin system notification list
 */
class SystemNotifications extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: true,
      sysNotifications : [],
    };
  }

  columns = [  
    {
      name: 'Notification Type',
      selector: 'name',
      sortable: true,
      ignoreRowClick: true,
    }   
  ];

  /**
   * @desc Get list of system notification
   */
  getAdminNotificatios() {
    this.props.getAdminNotificatiosAction().then(res => {
      this.setState({
        sysNotifications: this.props.sysNotifications || [],
      })
    }).catch(err => {
      this.setState({
        sysNotifications: [],
      })
    })
  }

  componentWillMount() {
    this.getAdminNotificatios();
  }

  render() {

    let rows = [];

    for (var i = 0, len = this.state.sysNotifications.length; i < len; i++) {
      let sysNotification = this.state.sysNotifications[i];

      let data = {
        id: sysNotification._id,        
        name: sysNotification.description,
      }
      rows.push(data);
    }

    return (
      <div>
        <Row className="mx-0 page-head-row page-head-row-big align-items-center">
          <Col>
            <h4 className="title-med mt-0 pt-1">
              System Notifications
            </h4>
          </Col>
        </Row>

        <div className="dt-content-area">
          <DataTable
            columns={this.columns}
            data={rows}
            sortIcon={<KeyboardArrowDown className="color-grey-1" />}
            noDataComponent={
              <div className="no-transaction no-record no-datatable">
                <div className="no-transaction-inner">
                  <img src={noRecord} alt="no record"/>
                  <p>No System notification Found</p>
                </div>
              </div>
            }
            highlightOnHover={true}
            className="rdt-requests"
            onRowSelected={this.getSelectedRows}
          />

        </div>
      </div>
    );
  }

}

const mapStateToProps = state => {
  return {
    sysNotifications: state.reducer.sysNotifications
  };
};

export default connect(mapStateToProps, { getAdminNotificatiosAction })(SystemNotifications)
